import { TB_TOOLS } from "@/components/orderRegisterTools";

// Admin: Order Register access level (viewer/editor) + allowed buttons.
// `allowed` null = every button allowed (default for existing users).
export const OrderRegRightsBox = ({ access, setAccess, allowed, setAllowed }) => {
  const all = TB_TOOLS.flatMap(g => g.items.map(i => i.id));
  const set = new Set(allowed ?? all);
  const toggle = (id, on) => {
    const next = new Set(set);
    on ? next.add(id) : next.delete(id);
    setAllowed(next.size === all.length ? null : [...next]);
  };
  return (
    <div className="mt-2 ml-5 p-2.5 rounded border border-indigo-200 bg-indigo-50/60" data-testid="orderreg-rights-box">
      <p className="text-[11px] font-semibold text-indigo-800 mb-1.5">Order Register rights</p>
      <div className="flex gap-2 mb-2">
        {[{ k: "editor", t: "Editor — can add / edit / upload / delete" },
          { k: "viewer", t: "Viewer — read-only (server-enforced)" }].map(o => (
          <label key={o.k} data-testid={`orderreg-access-${o.k}`}
            className={`flex-1 cursor-pointer rounded border px-2 py-1.5 text-[11px] transition-colors ${
              access === o.k ? "bg-indigo-600 text-white border-indigo-600" : "bg-white text-slate-700 border-slate-200 hover:border-indigo-300"}`}>
            <input type="radio" name="orderreg-access" className="sr-only" checked={access === o.k}
              onChange={() => setAccess(o.k)} />
            <b className="capitalize">{o.k}</b> <span className="opacity-80">· {o.t.split("— ")[1]}</span>
          </label>
        ))}
      </div>
      <div className="flex items-center justify-between mb-1">
        <span className="text-[11px] font-semibold text-slate-700">
          Allowed buttons <span className="font-normal text-slate-500">({set.size}/{all.length})</span>
        </span>
        <span className="flex gap-2 text-[10px]">
          <button type="button" className="text-indigo-700 hover:underline" data-testid="orderreg-btns-all"
            onClick={() => setAllowed(null)}>Select all</button>
          <button type="button" className="text-slate-500 hover:underline" data-testid="orderreg-btns-none"
            onClick={() => setAllowed([])}>Clear</button>
        </span>
      </div>
      <div className="max-h-56 overflow-y-auto bg-white rounded border border-slate-200 p-2 space-y-2">
        {TB_TOOLS.map(g => (
          <div key={g.group}>
            <p className="text-[10px] uppercase tracking-wide font-bold text-slate-400 mb-0.5">{g.group}</p>
            <div className="grid grid-cols-2 gap-x-3 gap-y-0.5">
              {g.items.map(it => (
                <label key={it.id} className="flex items-center gap-1.5 text-[11px] text-slate-700 cursor-pointer">
                  <input type="checkbox" checked={set.has(it.id)} data-testid={`orderreg-btn-${it.id}`}
                    onChange={(e) => toggle(it.id, e.target.checked)} />
                  {it.label}
                </label>
              ))}
            </div>
          </div>
        ))}
      </div>
      {access === "viewer" && (
        <p className="mt-1.5 text-[10px] text-indigo-700">
          Viewer: add / edit / upload / delete / cancel / price & tracking fill stay hidden and blocked even if ticked.
        </p>
      )}
    </div>
  );
};
